import { render, staticRenderFns } from "./homeApp.vue?vue&type=template&id=03a5b8fc&"
import script from "./homeApp.vue?vue&type=script&lang=js&"
export * from "./homeApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports